import React from "react"
import * as Yup from 'yup'
import { Button } from "@mui/material"
import { useFormik } from "formik"
import { store } from "../../../stores/Store"
import Field from "../fields/Field"
import { Value } from "sass"
import { DisplayDictionary } from "../../.."
import { formatFieldKey } from "../questionnaire/merge/mergeUtils"


export default function AutomationRefCodesSection ({
    automationOption,
    automationData,
    hidden = false,
    includeSubjectEmail = true,
    onCancel = () => {},
    onSubmit = async (values) => {}
}) {

    // Because this whole component is mounted before additional data is populated with the subject's email,
    // we need to update the formik value afterwards when the props update.
    React.useEffect(() => {
        if (automationData?.subject_email) {
            formik.setFieldValue("subject_email", automationData?.subject_email)
        }
    }, [automationData?.subject_email])

    const countryOptions = DisplayDictionary("countries", true)
    countryOptions.forEach(option => {
        option.value = option.label
    })
    const selectedCountryOption = !automationData?.subject_applying_from ? null : countryOptions.find((option) => {
        if (Array.isArray(automationData.subject_applying_from) && automationData.subject_applying_from.includes(option.label)) {
            return true
        }
        if (typeof automationData.subject_applying_from === "string" && automationData.subject_applying_from === option.label) {
            return true
        }
    })

    const formik = useFormik({
        initialValues: {
            // subject_applying_from: selectedCountryOption?.value,

            advisor_phone: automationData?.advisor_phone,
            advisor_email: automationData?.advisor_email,
            subject_phone: automationData?.subject_phone ? automationData?.subject_phone : automationData?.advisor_phone,
            subject_email: automationData?.subject_email ? automationData?.subject_email : automationData?.advisor_email,

            subject_supporter_has_brp: automationData?.subject_supporter_has_brp ? automationData.subject_supporter_has_brp : "false",
            subject_supporter_brp_number: automationData?.subject_supporter_brp_number,

            subject_supporter_uan_number_available: automationData?.subject_supporter_uan_number_available ? automationData.subject_supporter_uan_number_available : "false",
            subject_supporter_uan_number: automationData?.subject_supporter_uan_number,

            subject_supporter_gwf_number_available: automationData?.subject_supporter_gwf_number_available ? automationData.subject_supporter_gwf_number_available : "false",
            subject_supporter_gwf_number: automationData?.subject_supporter_gwf_number,

            cos_ref_number_available: automationData?.cos_ref_number_available ? automationData.cos_ref_number_available : "false",
            cos_ref_number: automationData?.cos_ref_number,

            cas_ref_number_available: automationData?.cas_ref_number_available ? automationData.cas_ref_number_available : "false",
            cas_ref_number: automationData?.cas_ref_number,

            advisor_case_reference_number_available: automationData?.advisor_case_reference_number_available ? automationData.advisor_case_reference_number_available : "false",
            advisor_case_reference_number: automationData?.advisor_case_reference_number,

            application_family_linking_code_avaliable: automationData?.application_family_linking_code_avaliable ? automationData.application_family_linking_code_avaliable : "false",
            application_family_linking_code_initiator_date_of_birth: automationData.subject_supporter_date_of_birth,
            application_family_linking_code: null


        },
        validationSchema: Yup.object({
            cos_ref_number: Yup.string().when("cos_ref_number_available", {
                is: (cos_ref_number_available) => cos_ref_number_available === "true",
                then: () => Yup.string().required("This field is required"),
                otherwise: () => Yup.string().nullable()
            }),

            cas_ref_number: Yup.string().when("cas_ref_number_available", {
                is: (cas_ref_number_available) => cas_ref_number_available === "true",
                then: () => Yup.string().required("This field is required"),
                otherwise: () => Yup.string().nullable()
            }),

            subject_supporter_uan_number: Yup.string().when("subject_supporter_uan_number_available", {
                is: (subject_supporter_uan_number_available) => subject_supporter_uan_number_available === "true",
                then: () => Yup.string().required("This field is required"),
                otherwise: () => Yup.string().nullable()
            }),
            
            subject_supporter_brp_number: Yup.string().when("subject_supporter_has_brp", {
                is: (subject_supporter_has_brp) => subject_supporter_has_brp === "true",
                then: () => Yup.string().matches(/^([A-Z]{2})([X0-9]){1}([0-9]{6})$/g, "BRP number must be 2 uppercase letters, followed by 'X' or a digit, followed by 6 digits.").required("This field is required"),
                otherwise: () => Yup.string().nullable()
            }),
            
            subject_supporter_gwf_number: Yup.string().when("subject_supporter_gwf_number_available", {
                is: (subject_supporter_gwf_number_available) => subject_supporter_gwf_number_available === "true",
                then: () => Yup.string().matches(/^(GWF)([0-9]{9})$/g, "Must be the letters 'GWF' followed by 9 numbers").required("This field is required"),
                otherwise: () => Yup.string().nullable()
            }),
            
            advisor_case_reference_number: Yup.string().when("advisor_case_reference_number_available", {
                is: (advisor_case_reference_number_available) => advisor_case_reference_number_available === "true",
                then: () => Yup.string().required("This field is required"),
                otherwise: () => Yup.string().nullable()
            }),

            application_family_linking_code_initiator_date_of_birth: Yup.string().when("application_family_linking_code_avaliable", {
                is: (application_family_linking_code_avaliable) => application_family_linking_code_avaliable === "true",
                then: () => Yup.string().required("This field is required"),
                otherwise: () => Yup.string().nullable()
            }),
            application_family_linking_code: Yup.string().when("application_family_linking_code_avaliable", {
                is: (application_family_linking_code_avaliable) => application_family_linking_code_avaliable === "true",
                then: () => Yup.string().required("This field is required"),
                otherwise: () => Yup.string().nullable()
            }),


        }),
        onSubmit: async (values) => {
            await onSubmit(values)
        }
    })

    if (hidden) return <></>

    return (
        <form className="form" onSubmit={formik.handleSubmit} style={{paddingTop: "0px"}}>

            <DisqualificationWarnings answers={automationData} />

            <p>You can amend some of your information before starting. Correspondence with the Home Office will go via the email addresses entered here.</p>

            <div style={{width: "100%", maxHeight: "500px", display: "grid", gap: "20px", overflowY: "auto"}}>
                <div style={{display: "grid", gridTemplateColumns: "49% 49%", gap: "2%"}}>
                    <Field.Text
                        formik
                        label="Advisor email"
                        name="advisor_email"
                        style={{maxWidth: "300px"}}
                        value={formik.values.advisor_email}
                        warning={formik.submitCount && formik.errors.advisor_email ? formik.errors.advisor_email : null}
                        onChange={formik.handleChange}  />

                    <Field.Text
                        formik
                        label="Applicant email"
                        name="subject_email"
                        style={{maxWidth: "300px"}}
                        // helpText="Enter the applicant's or preferred alternative email address to be used in the form."
                        value={formik.values.subject_email}
                        warning={formik.submitCount && formik.errors.subject_email ? formik.errors.subject_email : false}
                        onChange={formik.handleChange}  />

                    <Field.Text
                        formik
                        label="Advisor phone"
                        name="advisor_phone"
                        style={{maxWidth: "300px"}}
                        helpText="Include country code and swap the '+' for '00'."
                        value={formik.values.advisor_phone}
                        warning={formik.submitCount && formik.errors.advisor_phone ? formik.errors.advisor_phone : null}
                        onChange={formik.handleChange}  />

                    <Field.Text
                        formik
                        label="Applicant phone"
                        name="subject_phone"
                        style={{maxWidth: "300px"}}
                        helpText="Include country code and swap the '+' for '00'."
                        value={formik.values.subject_phone}
                        warning={formik.submitCount && formik.errors.subject_phone ? formik.errors.subject_phone : null}
                        onChange={formik.handleChange}  />

                    {/* {automationData?.subject_applying_from_uk === "false" ? (
                        <Field.Select
                            formik
                            label="Where are you applying from?"
                            name="subject_applying_from"
                            style={{maxWidth: "300px"}}
                            value={formik.values.subject_applying_from}
                            warning={formik.submitCount && formik.errors.subject_applying_from ? formik.errors.subject_applying_from : null}
                            options={countryOptions}
                            onChange={formik.handleChange}  />
                    ) : null} */}
                </div>

                <div className="form-fields">
                    {automationOption.id.startsWith("VAF") && !automationOption.id.includes("STU") ? (
                        <>
                            <Field.Checkbox
                                formik
                                value={formik.values.cos_ref_number_available === "true"}
                                name="cos_ref_number_available"
                                label="Do you know the worker's CoS reference number?"
                                warning={false}
                                onChange={() => {
                                    var newValue = formik.values.cos_ref_number_available === "true" ? "false" : "true"
                                    formik.setFieldValue("cos_ref_number_available", newValue)
                                }} />

                            {formik.values.cos_ref_number_available === "true" ? (
                                <Field.Text
                                    formik
                                    name="cos_ref_number"
                                    label="The worker's CoS reference number"
                                    style={{maxWidth: "300px"}}
                                    value={formik.values.cos_ref_number}
                                    warning={formik.errors.cos_ref_number ? formik.errors.cos_ref_number : false}
                                    onChange={formik.handleChange}  />
                            ) : null}
                        </>
                    ) : null}

                    {automationOption.id.startsWith("VAF_STU") ? (
                        <>
                            <Field.Checkbox
                                formik
                                value={formik.values.cas_ref_number_available === "true"}
                                name="cas_ref_number_available"
                                label="Do you know the student's CAS reference number?"
                                warning={false}
                                onChange={() => {
                                    var newValue = formik.values.cas_ref_number_available === "true" ? "false" : "true"
                                    formik.setFieldValue("cas_ref_number_available", newValue)
                                }} />

                            {formik.values.cas_ref_number_available === "true" ? (
                                <Field.Text
                                    formik
                                    name="cas_ref_number"
                                    label="The student's CAS reference number"
                                    style={{maxWidth: "300px"}}
                                    value={formik.values.cas_ref_number}
                                    warning={formik.errors.cas_ref_number ? formik.errors.cas_ref_number : false}
                                    onChange={formik.handleChange}  />
                            ) : null}
                        </>
                    ) : null}
                    
                    {automationOption.id.includes("DEP") ? (
                        <>
                            <Field.Checkbox
                                formik
                                value={formik.values.subject_supporter_gwf_number_available === "true"}
                                name="subject_supporter_gwf_number_available"
                                label="Do you know the workers Global Web Form (GWF) number?"
                                warning={false}
                                onChange={() => {
                                    var newValue = formik.values.subject_supporter_gwf_number_available === "true" ? "false" : "true"
                                    formik.setFieldValue("subject_supporter_gwf_number_available", newValue)
                                }} />

                            {formik.values.subject_supporter_gwf_number_available === "true" ? (
                                <Field.Text
                                    formik
                                    name="subject_supporter_gwf_number"
                                    label="The workers GWF number"
                                    style={{maxWidth: "300px"}}
                                    value={formik.values.subject_supporter_gwf_number}
                                    warning={formik.errors.subject_supporter_gwf_number ? formik.errors.subject_supporter_gwf_number : false}
                                    onChange={formik.handleChange}  />
                            ) : null}

                            <Field.Checkbox
                                formik
                                value={formik.values.subject_supporter_uan_number_available === "true"}
                                name="subject_supporter_uan_number_available"
                                label="Do you know the workers Unique Application Number (UAN)?"
                                warning={false}
                                onChange={() => {
                                    var newValue = formik.values.subject_supporter_uan_number_available === "true" ? "false" : "true"
                                    formik.setFieldValue("subject_supporter_uan_number_available", newValue)
                                }} />

                            {formik.values.subject_supporter_uan_number_available === "true" ? (
                                <Field.Text
                                    formik
                                    name="subject_supporter_uan_number"
                                    label="The workers UAN"
                                    style={{maxWidth: "300px"}}
                                    value={formik.values.subject_supporter_uan_number}
                                    warning={formik.errors.subject_supporter_uan_number ? formik.errors.subject_supporter_uan_number : false}
                                    onChange={formik.handleChange}  />
                            ) : null}

                            {automationData?.subject_applying_from_uk === "true" ? (
                                <>
                                    <Field.Checkbox
                                        formik
                                        value={formik.values.subject_supporter_has_brp === "true"}
                                        name="subject_supporter_has_brp"
                                        label="Do you know the workers Biometric Residence Permit (BRP) number?"
                                        warning={false}
                                        onChange={() => {
                                            var newValue = formik.values.subject_supporter_has_brp === "true" ? "false" : "true"
                                            formik.setFieldValue("subject_supporter_has_brp", newValue)
                                        }} />

                                    {formik.values.subject_supporter_has_brp === "true" ? (
                                        <Field.Text
                                            formik
                                            name="subject_supporter_brp_number"
                                            label="The workers BRP number"
                                            style={{maxWidth: "300px"}}
                                            value={formik.values.subject_supporter_brp_number}
                                            warning={formik.errors.subject_supporter_brp_number ? formik.errors.subject_supporter_brp_number : false}
                                            onChange={formik.handleChange}  />
                                    ) : null}
                                </>
                            ) : null}
                        </>
                    ) : null}


                    <Field.Checkbox
                        formik
                        label="Do you have a reference number for this application?"
                        name="advisor_case_reference_number_available"
                        value={formik.values.advisor_case_reference_number_available === "true"}
                        warning={formik.submitCount && formik.errors.advisor_case_reference_number_available ? formik.errors.advisor_case_reference_number_available : null}
                        onChange={(e) => {
                            formik.setFieldValue("advisor_case_reference_number_available", formik.values.advisor_case_reference_number_available === "true" ? "false" : "true")
                        }}  />

                    {formik.values.advisor_case_reference_number_available === "true" ? (
                        <Field.Text
                            formik
                            label="Your reference number for this application"
                            name="advisor_case_reference_number"
                            style={{maxWidth: "300px"}}
                            value={formik.values.advisor_case_reference_number}
                            warning={formik.submitCount && formik.errors.advisor_case_reference_number ? formik.errors.advisor_case_reference_number : false}
                            onChange={formik.handleChange}  />
                    ) : null}


                    {automationOption.id.startsWith("VAF_DEP") ? (
                        <>
                            <Field.Checkbox
                                formik
                                value={formik.values.application_family_linking_code_avaliable === "true"}
                                name="application_family_linking_code_avaliable"
                                label="Do you have a family linking code?"
                                // helpText="You may have acquired a 'family linking code' if the main applicant has already started applying."
                                warning={false}
                                onChange={() => {
                                    var newValue = formik.values.application_family_linking_code_avaliable === "true" ? "false" : "true"
                                    formik.setFieldValue("application_family_linking_code_avaliable", newValue)
                                }} />

                            {formik.values.application_family_linking_code_avaliable === "true" ? (
                                <>
                                    <Field.Text
                                        formik
                                        name="application_family_linking_code"
                                        label="Your family linking code?"
                                        style={{maxWidth: "300px"}}
                                        value={formik.values.application_family_linking_code}
                                        warning={formik.errors.application_family_linking_code ? formik.errors.application_family_linking_code : false}
                                        onChange={formik.handleChange}  />

                                    <Field.Date
                                        formik
                                        name="application_family_linking_code_initiator_date_of_birth"
                                        label="The date of birth of the person who recieved the family linking code?"
                                        style={{maxWidth: "300px"}}
                                        value={formik.values.application_family_linking_code_initiator_date_of_birth}
                                        warning={formik.errors.application_family_linking_code_initiator_date_of_birth ? formik.errors.application_family_linking_code_initiator_date_of_birth : false}
                                        onChange={formik.handleChange}  />
                                </>
                            ) : null}
                        </>
                    ) : null}
                </div>
            </div>

            <div className="form-buttons">
                <Button className="btn btn-sm" onClick={() => onCancel()}>Back</Button>

                <Button
                    disabled={formik.isSubmitting}
                    className="btn btn-sm"
                    type="submit"
                    color="success"
                    variant="contained">
                    Confirm and start automation
                </Button>
            </div>
        </form>
    )
}


function DisqualificationWarnings ({answers}) {

    const disqualificationValues = {
        "subject_involved_in_war_crimes": "true",
        "subject_supported_terrorist_activities": "true",
        "subject_supported_terrorist_organisations": "true",
        "subject_expressed_terrorist_views": "true",
        "subject_has_been_a_involved_with_an_extremist_organisation": "true",
        "subject_has_expressed_extremist_views": "true",
        "subject_has_been_employed_by_hostile_government": "true",
        "subject_has_engaged_in_activities_considered_not_to_be_of_good_character": "true",
        // "subject_has_anything_else_to_come_clean_about": "true",
    }

    const disqualifiedAnswers = Object.keys(disqualificationValues).filter((fieldKey, i) => answers[fieldKey] === disqualificationValues[fieldKey])

    if (!disqualifiedAnswers.length) return <></>

    return (
        <div className="warning">
            <p><b>You have some information which may cause your application to be rejected.</b></p>

            {disqualifiedAnswers.map((fieldKey, i) => (
                <div key={i}>
                    {formatFieldKey(fieldKey)}
                </div>
            ))}
        </div>
    )
}